import { render, staticRenderFns } from "./HeaderTemplateForm.vue?vue&type=template&id=6a0ea9a0&"
import script from "./HeaderTemplateForm.vue?vue&type=script&lang=js&"
export * from "./HeaderTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports